<template>
    <div class="breadcrumb">
        <main-container>
            <div v-if="section" class="item">
                <chevron />
                <router-link :to="section.to" class="link">
                    <typo name="menu-12-bold">
                        {{ section.title }}
                    </typo>
                </router-link>
            </div>
            <div class="item" v-for="item in items" :key="item._uid">
                <chevron />
                <router-link :to="item.to" class="link">
                    <typo name="menu-12-bold">
                        {{ item.label }}
                    </typo>
                </router-link>
            </div>
            <div v-if="title" class="item">
                <chevron />
                <typo name="menu-12-bold">
                    {{ title }}
                </typo>
            </div>
        </main-container>
    </div>
</template>

<script>
import Chevron from "../icons/Chevron.vue";

import { map, flatten } from "lodash";
import { Services } from "src/services/Services";

export default {
    props: ["section", "title"],
    components: { Chevron },
    mounted() {},
    asyncComputed: {
        async items() {
            const promises = map(
                this.$route.matched.filter(i => i.meta.type != "espace-client"),
                async i => {
                    const params = this.$route.params;
                    if (i.meta.type === "convention") {
                        const convention = await Services.api.convention.getByConventionId(
                            params.conventionId,
                            params.variantNumber
                        );
                        return {
                            label: convention.title,
                            to: `/espace-client/conventions-collectives/${params.conventionId}/${params.variantNumber}`,
                        };
                    } else if (i.meta.type === "article") {
                        const article = await Services.api.mag.getArticleBySlugOrContentId(
                            params.slugOrContentId
                        );
                        const category = article.category;
                        return [
                            { label: category.title, to: `/espace-client/mag?category=${category.name}` },
                            { label: article.title, to: `/espace-client/mag/${params.slugOrContentId}` },
                        ];
                    }
                    return { label: i.meta.title, to: "/espace-client" };
                }
            );
            const paths = await Promise.all(promises);
            return flatten(paths);
        },
    },
};
</script>

<style scoped lang="sass">
.breadcrumb
    height: 50px
    display: flex
    background: white

.main-container
    display: flex
    align-items: center
    flex-grow: 1

.chevron
    fill: $color-secondary
    margin-right: 0px
    width: 8px
    height: 8px
    position: relative

.item
    padding: 0 5px
    margin-left: -5px
    white-space: nowrap
    max-width: 500px
    overflow: hidden
    text-overflow: ellipsis

.link
    color: $color-secondary
    text-decoration: none
    &:hover
        color: $color-main
@media print
    .breadcrumb
        display: none
</style>
